import {Fragment} from "react";

import {kmAppLink} from "@pg-mono/km-routes";

import {useKMLink} from "../../hooks/use_km_link";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";

// The link is built on render - `useKMLink` appends the cookie consent, which is available only after mount.
const KMFavouritesLink = () => {
    const kmFavouritesLink = useKMLink(kmAppLink.site.offers.favouritesWithParams);

    return (
        <a href={kmFavouritesLink} target="_blank" title="Ulubione" style={{textDecoration: "underline"}}>
            Zobacz listę
        </a>
    );
};

export const addRealEstateToFavouritesSuccess = addSuccessNotification(
    <Fragment>
        Dodałeś ofertę do ulubionych <br /> <br />
        <strong>
            <KMFavouritesLink />
        </strong>
        <br />
    </Fragment>
);

export const removeRealEstateFromFavouritesSuccess = addSuccessNotification("Usunąłeś ofertę z ulubionych");
import {Fragment} from "react";

import {kmAppLink} from "@pg-mono/km-routes";

import {useKMLink} from "../../hooks/use_km_link";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";

// The link is built on render - `useKMLink` appends the cookie consent, which is available only after mount.
const KMFavouritesLink = () => {
    const kmFavouritesLink = useKMLink(kmAppLink.site.offers.favouritesWithParams);

    return (
        <a href={kmFavouritesLink} target="_blank" title="Ulubione" style={{textDecoration: "underline"}}>
            Zobacz listę
        </a>
    );
};

export const addRealEstateToFavouritesSuccess = addSuccessNotification(
    <Fragment>
        Dodałeś ofertę do ulubionych <br /> <br />
        <strong>
            <KMFavouritesLink />
        </strong>
        <br />
    </Fragment>
);

export const removeRealEstateFromFavouritesSuccess = addSuccessNotification("Usunąłeś ofertę z ulubionych");
